export * from "-!../node_modules/extract-text-webpack-plugin/dist/loader.js??ref--5-0!../node_modules/vue-style-loader/index.js!../node_modules/css-loader/index.js??ref--5-2!../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../node_modules/postcss-loader/lib/index.js??ref--5-3!../node_modules/vue-loader/lib/index.js??vue-loader-options!./App.vue?vue&type=style&index=1&id=dbf4d1f4&prod&lang=css"


//////////////////
// WEBPACK FOOTER
// ./src/App.vue?vue&type=style&index=1&id=dbf4d1f4&prod&lang=css
// module id = +Rh0
// module chunks = 1